"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
require("../styles/Link.css");
var _Display_icon = _interopRequireDefault(require("../assets/Display_icon.png"));
var _Hide_icon = _interopRequireDefault(require("../assets/Hide_icon.png"));
var _dayjs = _interopRequireDefault(require("dayjs"));
require("dayjs/locale/fr");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : PasswordForm.js
* Description : Ce fichier contient la définition du composant PasswordForm 
*               Ce composant affiche un champ pour rentrer un mot de passe avec une fonction de validation son format
* Date de création : 20 juin 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */ // définit 'fr' comme locale globale
_dayjs["default"].locale('fr');
var duration = require("dayjs/plugin/duration");
_dayjs["default"].extend(duration);

/**
* PasswordForm : ce lien affiche un champ pour rentrer un mot de passe avec un affichage caché
*
* Type : composant 
*
* Parametres : 
*  - error -- booléen pour remonter une erreur de validation du format du mot de passe
*  - label -- texte affiché au dessus du champ pour apporter des précisions 
*  - value -- valeur du mot de passe
*  - setValue -- fonction pour mettre à jour la valeur du mot de passe
*  - disabled -- booléen pour désactiver la saisie de ce champ et juste afficher sa valeur si elle dépend d'autres variables
*/
function PasswordForm(_ref) {
  var error = _ref.error,
    label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue,
    disabled = _ref.disabled;
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    shown = _useState2[0],
    setShown = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _dayjs["default"])()),
    _useState4 = _slicedToArray(_useState3, 2),
    dateShown = _useState4[0],
    setDateShown = _useState4[1];
  var refShown = (0, _react.useRef)(shown);
  var refDateShown = (0, _react.useRef)(dateShown);

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  var handleShown = function handleShown(event) {
    event.preventDefault();
    if (shown === false) {
      setDateShown((0, _dayjs["default"])());
      setShown(true);
    } else {
      setShown(false);
    }
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    refShown.current = shown;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shown]);
  (0, _react.useEffect)(function () {
    refDateShown.current = dateShown;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateShown]);
  (0, _react.useEffect)(function () {
    // Utilisation d'un setInterval dans un useEffect pour exécuter quelque chose en continu dans le temps (comme une boucle ou un minuteur)
    // Quand setInterval est créé, il capture les valeurs du moment, et ne voit pas les mises à jour de state => utilisation de useRef
    var interval = setInterval(function () {
      if (refShown.current === true && _dayjs["default"].duration(refDateShown.current.diff()) <= -30000) {
        setShown(false);
      }
    }, 1000);
    return function () {
      return clearInterval(interval);
    }; // Nettoyage quand le composant se démonte
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render component
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'form-label flex-column' : screenWidth > 650 ? 'form-label-ss flex-column' : 'form-label-tr flex-column',
    children: [label, " :", /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        className: "form-input-error",
        type: shown ? "text" : "password",
        value: value,
        onChange: function onChange(e) {
          return setValue(e.target.value);
        },
        disabled: disabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: shown ? _Hide_icon["default"] : _Display_icon["default"],
        alt: shown ? 'hide_icon' : 'display_icon',
        onClick: handleShown,
        className: "flex-row form-icon-password"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'form-label flex-column' : screenWidth > 650 ? 'form-label-ss flex-column' : 'form-label-tr flex-column',
    children: [label, ":", /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        className: "form-input",
        type: shown ? "text" : "password",
        value: value,
        onChange: function onChange(e) {
          return setValue(e.target.value);
        },
        disabled: disabled
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: shown ? _Hide_icon["default"] : _Display_icon["default"],
        alt: shown ? 'hide_icon' : 'display_icon',
        onClick: handleShown,
        className: "flex-row form-icon-password"
      })]
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
PasswordForm.propTypes = {
  error: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setValue: _propTypes["default"].func
};
var _default = exports["default"] = PasswordForm;